export default __webpack_public_path__ + "static/badminton-bg-image-c556fb61d154de1f3053c99e22cadddc.png";